import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import InfoIcon from '@material-ui/icons/InfoOutlined'
import Fade from '@material-ui/core/Fade'
import TealToolTip from 'components/TealToolTip'
import { pushEvent } from 'services/AnalyticsService'

const InfoHelperButton = ({ searchHelperVisible, setSearchHelperVisible, inputRef }) => {
  const handleOnClick = (e) => {
    inputRef.current.focus()
    pushEvent({
      category: 'Search',
      action: 'Click',
      label: 'Helper Icon'
    })
    setSearchHelperVisible(!searchHelperVisible)
  }

  return (
    <Fade in={!searchHelperVisible} timeout={500}>
      <TealToolTip title='View Search Tips' placement='top' enterDelay={800}>
        <IconButton
          size='small'
          className='absolute right2 top-50 y--50 cadet-blue hover-dark-slate-blue'
          onClick={handleOnClick}
          data-testid='search-tips-icon'
        >
          <InfoIcon />
        </IconButton>
      </TealToolTip>
    </Fade>
  )
}

export default InfoHelperButton
